import React from 'react';
import { CommonCancellationAlertBody } from '@components/Alerts/NotificationAlert/CommonCancellationAlertBody/CommonCancellationAlertBody';

export const CancelledAlertBody = () => {
	return (
		<CommonCancellationAlertBody
			message="Procedure successfully canceled."
		/>
	);
};
